function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-10);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -1.919,
  y1: 0.5,
  x2: 9.261,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3023ae"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c86dd7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: -3.293,
  y1: 0.5,
  x2: 9.078,
  y2: 0.5,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: -4.286,
  y1: 0.5,
  x2: 7.879,
  y2: 0.5,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: -5.442,
  y1: 0.5,
  x2: 6.93,
  y2: 0.5,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: -6.362,
  y1: 0.5,
  x2: 5.75,
  y2: 0.5,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: -25.864,
  y1: 0.5,
  x2: 16.256,
  y2: 0.5,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: -7.228,
  y1: 0.5,
  x2: 4.012,
  y2: 0.5,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: -7.988,
  y1: 0.5,
  x2: 3.25,
  y2: 0.5,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: -33.919,
  y1: 0.5,
  x2: 8.202,
  y2: 0.5,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: -1.622,
  y1: 0.5,
  x2: 2.619,
  y2: 0.5,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Logo",
  transform: "translate(-21.006 -7.894)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_35",
  "data-name": "Grupo 35",
  transform: "translate(21.006 56.426)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_15",
  "data-name": "Trazado 15",
  className: "cls-1",
  d: "M32.149,124.405a.609.609,0,0,0-.58-.423h-4.49a.609.609,0,0,0-.579.422l-5.464,16.951a.609.609,0,0,0,.579.8h3.1a.608.608,0,0,0,.585-.442l.933-3.281a.609.609,0,0,1,.586-.443h4.7a.609.609,0,0,1,.586.444l.922,3.278a.608.608,0,0,0,.586.444H37a.609.609,0,0,0,.58-.795ZM30.39,134.8H27.971a.609.609,0,0,1-.586-.773l1.713-6.108h.2l1.679,6.111A.609.609,0,0,1,30.39,134.8Z",
  transform: "translate(-21.006 -123.663)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_16",
  "data-name": "Trazado 16",
  className: "cls-2",
  d: "M77.136,123.982H74.192a.565.565,0,0,0-.565.564v10.191h-.146l-7.139-10.508a.564.564,0,0,0-.467-.247H63.264a.565.565,0,0,0-.564.564v17.04a.564.564,0,0,0,.564.564H66.2a.564.564,0,0,0,.564-.564v-10.3h.16L74.072,141.9a.564.564,0,0,0,.468.249h2.6a.564.564,0,0,0,.564-.564v-17.04A.565.565,0,0,0,77.136,123.982Z",
  transform: "translate(-45.155 -123.663)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_17",
  "data-name": "Trazado 17",
  className: "cls-3",
  d: "M115.474,123.982h-3.448a.479.479,0,0,0-.479.479v10.875c0,2.289-1.318,3.474-3.221,3.474s-3.234-1.158-3.234-3.474V124.461a.479.479,0,0,0-.479-.479h-3.434a.479.479,0,0,0-.479.479v11.487c0,3.927,2.888,6.536,7.627,6.536s7.627-2.609,7.627-6.536V124.461A.479.479,0,0,0,115.474,123.982Z",
  transform: "translate(-67.163 -123.663)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_18",
  "data-name": "Trazado 18",
  className: "cls-4",
  d: "M153.721,123.982h-2.912a.581.581,0,0,0-.581.581v10.174h-.146l-7.134-10.5a.58.58,0,0,0-.48-.254h-2.586a.581.581,0,0,0-.581.581V141.57a.58.58,0,0,0,.581.58h2.9a.58.58,0,0,0,.581-.58V131.289h.16l7.148,10.605a.58.58,0,0,0,.481.256h2.571a.58.58,0,0,0,.581-.58V124.563A.581.581,0,0,0,153.721,123.982Z",
  transform: "translate(-89.521 -123.663)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_19",
  "data-name": "Trazado 19",
  className: "cls-5",
  d: "M184.854,123.223c-5.058,0-7.893,3.261-7.893,8.466v1.917c0,5.178,2.835,8.439,7.893,8.439,4.313,0,7.427-2.583,7.427-6.429v-.532h-3.573a.694.694,0,0,0-.679.607,3.01,3.01,0,0,1-3.136,2.72c-2.2,0-3.447-1.69-3.447-4.778v-1.943c0-3.128,1.251-4.832,3.447-4.832a3.035,3.035,0,0,1,3.138,2.811.692.692,0,0,0,.679.61h3.571v-.519C192.282,125.832,189.18,123.223,184.854,123.223Z",
  transform: "translate(-111.333 -123.223)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_12",
  "data-name": "Rect\\xE1ngulo 12",
  className: "cls-6",
  width: 4.406,
  height: 18.169,
  rx: 1.267,
  transform: "translate(82.106 0.319)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_20",
  "data-name": "Trazado 20",
  className: "cls-7",
  d: "M240.039,124.488a.729.729,0,0,0-.694-.506h-4.315a.728.728,0,0,0-.693.5L228.949,141.2a.728.728,0,0,0,.693.951h2.842a.728.728,0,0,0,.7-.529l.884-3.108a.728.728,0,0,1,.7-.529h4.515a.728.728,0,0,1,.7.531l.873,3.1a.727.727,0,0,0,.7.531H244.7a.728.728,0,0,0,.694-.95ZM238.1,134.8h-2.1a.728.728,0,0,1-.7-.925l1.671-5.957h.2l1.637,5.96A.728.728,0,0,1,238.1,134.8Z",
  transform: "translate(-141.423 -123.663)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_21",
  "data-name": "Trazado 21",
  className: "cls-8",
  d: "M274.611,123.982h-3.383a.683.683,0,0,0-.662.515l-3.277,12.928H267.1l-3.329-12.931a.684.684,0,0,0-.662-.513h-3.647a.683.683,0,0,0-.651.89l5.342,16.8a.684.684,0,0,0,.651.476h4.536a.683.683,0,0,0,.652-.479l5.268-16.8A.683.683,0,0,0,274.611,123.982Z",
  transform: "translate(-158.722 -123.663)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_13",
  "data-name": "Rect\\xE1ngulo 13",
  className: "cls-9",
  width: 4.406,
  height: 18.169,
  rx: 1.31,
  transform: "translate(117.594 0.319)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_22",
  "data-name": "Trazado 22",
  className: "cls-10",
  d: "M128.817,48.794a1.538,1.538,0,0,0,.829-.419,64.918,64.918,0,0,0,8.64-10.547.026.026,0,0,1,.017-.011l12.869-2.1a8.69,8.69,0,0,0,7.156-9.947L156.6,15.162a8.69,8.69,0,0,0-9.947-7.155L125.736,11.42a8.69,8.69,0,0,0-7.156,9.947L120.316,32a8.669,8.669,0,0,0,8.9,7.238.024.024,0,0,1,.026.025,20.818,20.818,0,0,1-2.04,7.29,1.608,1.608,0,0,0,.578,2.045A1.542,1.542,0,0,0,128.817,48.794Zm5.7-33.636,10.436,6.074a1.431,1.431,0,0,1,.355,2.182l-7.972,9.069a1.431,1.431,0,0,1-2.488-.715l-2.463-15.143A1.431,1.431,0,0,1,134.515,15.158Z",
  transform: "translate(-56.448 0)"
}));

function SvgLogofooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122,
    height: 67.354,
    viewBox: "0 0 122 67.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogofooter);
export default __webpack_public_path__ + "static/media/Logofooter.20400f87.svg";
export { ForwardRef as ReactComponent };